<template>
  <v-container
    fill-height
    fluid
    grid-list-md
  >
    <v-layout
      justify-center
      wrap
    >
      <CompanyCondition />
      <v-layout row>
        <v-flex
          md12
        >
          <MaterialCard
            color="green"
            full-width
          >
            <v-data-table
              :headers="headers"
              :items="items"
              hide-actions
            >
              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="subheading font-weight-light text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template
                slot="items"
                slot-scope="{ item }"
              >
                <tr @click="selected = item">
                  <td>{{ item.id }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.tel }}</td>
                  <td>{{ item.manager }}</td>
                  <td>{{ item.sensorsRest }}</td>
                  <td>{{ item.users }}</td>
                </tr>
              </template>
            </v-data-table>
          </MaterialCard>
        </v-flex>
        <v-flex md4>
          <CompanyDetail
            :company="selected"
          />
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import { CompanyCondition, CompanyDetail } from './components'
import { onError } from '@/utils/error-handler'
import { api } from '@/api'

export default {
  components: {
    CompanyCondition,
    CompanyDetail
  },
  async beforeRouteEnter (to, from, next) {
    try {
      const response = await api.searchCompanies()

      next(vm => {
        vm.init(response)
      })
    } catch (e) {
      onError(next, e)
    }
  },
  data: () => ({
    headers: [
      { sortable: true, text: '#', value: 'id' },
      { sortable: false, text: '会社名', value: 'name' },
      { sortable: false, text: '電話番号', value: 'tel' },
      { sortable: false, text: '代表', value: 'representativeName' },
      { sortable: true, text: 'センサー残', value: 'sensorsRest' },
      { sortable: false, text: 'ユーザ数', value: 'users' }
    ],
    items: [],
    selected: {}
  }),
  methods: {
    init (response) {
      this.items.push(...response.companies.map(c => ({
        id: c.id,
        name: c.name,
        headOfficeLocation: c.headOfficeLocation,
        address: c.address,
        tel: c.tel,
        representativeName: (c.representative && c.representative.name) || '',
        remarks: c.remarks,
        updatedAt: c.updatedAt,
        sensorsRest: 0,
        users: 0
      })))
    }
  }
}

export const search = async (query) => {

}
</script>
